import { render } from "./AirdropPage.vue?vue&type=template&id=1ee2eb27&scoped=true"
import script from "./AirdropPage.vue?vue&type=script&lang=js"
export * from "./AirdropPage.vue?vue&type=script&lang=js"

import "./AirdropPage.vue?vue&type=style&index=0&id=1ee2eb27&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee2eb27"]])

export default __exports__